<template>
    <div>
        <!-- Like button    
        <button class="like fab-btn mini is-single" data-toggle="tooltip" 
        data-placement="left" data-title="Liked by 64 persons" :class="{'is-active': isActive}" @click="likeThis(recipe.id)">
            <span class="like-wrapper">
                <i class="material-icons not-liked bouncy">favorite_border</i>
                <i class="material-icons is-liked bouncy"
                :class="{'is-active': isActive}"
                >favorite</i>
                <span class="like-overlay"></span>
            </span>
        </button>
        --> 
        <a class="like-button" :class="{'is-active': isActive}" @click="likeThis(recipe)">
            <i class="material-icons not-liked bouncy">favorite_border</i>
            <i class="material-icons is-liked bouncy">favorite</i>
            <span class="like-overlay"></span>
        </a>
    </div>
</template>

<script>
import db from '@/db';        
import firebase from '@/firebase';

export default {
    data() {
        return {
            likeableRef: Object,
            isActive: false,
            loggedInUser: firebase.auth().currentUser,
        };
    },
    props: {
        recipe: {
            type: Object,
            required: true
        }
    },
    mounted() {
        const vm = this;
            if(this.loggedInUser) {
                this.likeableRef = db.collection('recipeLikeables').doc(firebase.auth().currentUser.uid + ':' + this.recipe.id);
                    this.likeableRef.get().then(function(doc) {
                        if (doc.exists) {
                            vm.isActive = true;
                        }
                    }).catch(function(error) {
                        console.log("Error getting document:", error);
                    });
            }
    },
    methods: {
        likeThis(recipe) {
            
            if(this.loggedInUser) {
            const likeableRef = this.likeableRef;
            const user_id = firebase.auth().currentUser.uid;
            const recipe_id = recipe.id;
            this.likeableRef.get().then(function(doc) {
                if (doc.exists) {
                    likeableRef.delete();
                } else {
                    likeableRef.set({
                        id: user_id + ":" + recipe_id,
                        user_id: user_id,
                        recipe_id: recipe_id,
                        state: 1
                    });
            let newNotificationRef = db.collection('users').doc(recipe.user_id).collection('notifications').doc();
                    db.collection('users').doc(user_id).get().then(function(doc) {
                        if (doc.exists) {                            
                            newNotificationRef.set({
                                id:newNotificationRef.id,
                                read:false,
                                type:'like',
                                typeId:doc.data().id,
                                user_id: doc.data().id,
                                kitchen_name: doc.data().kitchen_name,
                                message: doc.data().kitchen_name + ' Started following your recipe for ' + recipe.name
                            })
                        }
                    }).catch(function(error) {
                        console.log("Error getting document:", error);
                    });

                }
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });
            this.isActive = !this.isActive;
            }
            else{
                this.$router.replace("/login");
            }
        },
    }
};
</script>